import Modal from './Modal';

function ReloadModal() {
  return (
    <Modal preventClose={true}>
      <div className="flex flex-col items-center justify-center text-center bg-white" style={{ width: "400px", height: "140px" }}>
        <div className="text-2xl font-gilroy font-semibold text-gray-600">Session Expired</div>
        <div className="font-semibold">Reload this page to continue using Portant</div>
        <button className="btn btn-blue mt-auto w-80" onClick={() => window.location.reload()}>
          Reload
        </button>
      </div>
    </Modal>
  );
}

export default ReloadModal;
